import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaWhatsapp } from 'react-icons/fa';
import { HiOutlineMail, HiOutlineCalendar } from 'react-icons/hi';
import { BiPlusCircle, BiMinusCircle } from 'react-icons/bi';
import contact from '../../assets/images/contact-us.svg';
import Wrapper from './Contact_styles';

const metaTitle = 'Terzo pilastro - Contattaci ora per una nuova proposta';
const metaDescription =
  'Contattaci subito per avere maggiori informazioni e un preventivo rapido per una nuova soluzione. Scegli tu il metodo di contatto: via Whatsapp o con una mail, saremo pronti a risponderti nel più breve tempo possibile.';

const Contact = () => {
  const [openAccordion, setOpenAccordion] = useState(null);

  return (
    <Wrapper>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
      </Helmet>
      <div className="container">
        <section className="hero-section">
          <h1>Contatto</h1>
          <p className="hero-text">
            Siamo a tua disposizione se hai bisogno di noi. Sul canale più
            pratico per te.
          </p>
          <img className="img" src={contact} alt="Contact Us" />
        </section>

        <section className="contact">
          <div className="item phone-us">
            <button
              type="button"
              onClick={() =>
                setOpenAccordion(openAccordion === 'phone' ? null : 'phone')
              }
            >
              <h5>
                Chatta con noi su WhatsApp{' '}
                {openAccordion === 'phone' ? (
                  <BiMinusCircle />
                ) : (
                  <BiPlusCircle />
                )}
              </h5>
            </button>
            <div
              className={
                openAccordion === 'phone' ? 'accordion open' : 'accordion'
              }
            >
              <div>
                <h3>Possiamo aiutarti?</h3>
                <p>Chatta con noi su WhatsApp</p>
                <a
                  href="https://wa.me/+41918808787"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline btn-hero"
                >
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </div>

          <div className="item mail-us">
            <button
              type="button"
              onClick={() =>
                setOpenAccordion(openAccordion === 'mail' ? null : 'mail')
              }
            >
              <h5>
                Scrivici una mail{' '}
                {openAccordion === 'mail' ? (
                  <BiMinusCircle />
                ) : (
                  <BiPlusCircle />
                )}
              </h5>
            </button>
            <div
              className={
                openAccordion === 'mail' ? 'accordion open' : 'accordion'
              }
            >
              <div>
                <h3>Possiamo aiutarti?</h3>
                <p>Scrivici una mail</p>
                <a
                  href="mailto:info@elefin.ch"
                  rel="noopener noreferrer"
                  className="btn btn-outline btn-hero"
                >
                  <HiOutlineMail />
                </a>
              </div>
            </div>
          </div>
          
          <div className="item schedule">
            <button
              type="button"
              onClick={() =>
                setOpenAccordion(openAccordion === 'schedule' ? null : 'schedule')
              }
            >
              <h5>
              Prenota un appuntamento
                {openAccordion === 'schedule' ? (
                  <BiMinusCircle />
                ) : (
                  <BiPlusCircle />
                )}
              </h5>
            </button>
            <div
              className={
                openAccordion === 'schedule' ? 'accordion open' : 'accordion'
              }
            >
              <div>
                <h3>Possiamo aiutarti?</h3>
                <p>Prenota un appuntamento</p>
                <a
                  href="https://calendly.com/terzopilastro"
                  target='_blank'
                  rel="noopener noreferrer"
                  className="btn btn-outline btn-hero"
                >
                  <HiOutlineCalendar />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Wrapper>
  );
};

export default Contact;
